
(function(){
  const targetNode = document.querySelector('product-recommendations');
  if (!targetNode) return;

  const config = { attributes: true, attributeFilter: ['class'] };

  function initIfReady(root){
    const $slider = $('.related-product-slider', root);
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;

    const $wrap = $(root); // scope to this product-recommendations
    const $prev = $wrap.find('.slide-buttons .slick-prev');
    const $next = $wrap.find('.slide-buttons .slick-next');
    const $status = $wrap.find('.pagingInfo');
    const $bar = $wrap.find('.slider-progress .progress-bar');

    function getPages(slick){
      const count = slick.slideCount || 0;
      const show = Number(slick.options.slidesToShow) || 1;
      const scroll = Number(slick.options.slidesToScroll) || 1;
      const raw = Math.ceil(Math.max(0, (count - show)) / scroll) + 1;
      return Math.max(1, raw);
    }
    function getCurrentPage(slick){
      const scroll = Number(slick.options.slidesToScroll) || 1;
      const idx = (slick.currentSlide || 0);
      return Math.floor(idx / scroll) + 1;
    }
    function updateStatusAndProgress(slick){
      if (slick && slick.slideCount !== undefined){
        const totalPages = getPages(slick);
        const currentPage = Math.min(getCurrentPage(slick), totalPages);
        if ($status.length){
          if (totalPages > 1){
            $status.text(currentPage + ' / ' + totalPages).show();
          } else {
            $status.text('').hide();
          }
        }
        if ($bar.length){
          const percent = (currentPage / totalPages) * 100;
          $bar.css({ width: percent + '%' });
        }
        // Disable/enable arrows at edges (infinite false)
        if (!$prev.is('.hidden')) {
          $prev.prop('disabled', currentPage <= 1);
          $next.prop('disabled', currentPage >= totalPages);
        }
      }
    }

    $slider
      .on('init reInit afterChange setPosition', function(e, slick){
        updateStatusAndProgress(slick);
      })
      .slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4.2,
        slidesToScroll: 4,
        autoplay: false,
        prevArrow: $prev,
        nextArrow: $next,
        responsive: [
          {
            breakpoint: 1025,
            settings: { slidesToShow: 2.4, slidesToScroll: 2, infinite: false, dots: true }
          },
          {
            breakpoint: 769,
            settings: { slidesToShow: 1.4, slidesToScroll: 1, dots: true }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1.2, slidesToScroll: 1, dots: true }
          }
        ]
      });
  }

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // when recommendations load and class changes, init
        initIfReady(mutation.target);
      }
    }
  });

  observer.observe(targetNode, config);

  // Fallback: if already loaded and class won't change again
  initIfReady(targetNode);
})();